import { render, staticRenderFns } from "./ConsentGA.vue?vue&type=template&id=5d272c85&scoped=true"
import script from "./ConsentGA.vue?vue&type=script&lang=ts"
export * from "./ConsentGA.vue?vue&type=script&lang=ts"
import style0 from "./ConsentGA.vue?vue&type=style&index=0&id=5d272c85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d272c85",
  null
  
)

export default component.exports